import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton } from '@purpurds/purpur/skeleton';
import { InfoBox } from 'components/InfoBox/info-box';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const HealthCheckListContainerHeader = styled.div `
  font-size: 20px;
  display: flex;
  align-items: center;
  margin: ${spacing.spacing20} 0 0 ${spacing.spacing16};
  height: 30px;
`;
const StyledSkeleton = styled(Skeleton) `
  width: 100%;
  height: 4rem;
  margin-top: ${spacing.spacing4};
`;
export const HealthCheckSection = ({ title, isLoading, error, hasItems, emptyText, children, }) => (_jsxs(_Fragment, { children: [_jsx(HealthCheckListContainerHeader, { children: title }), _jsxs("div", { children: [isLoading && _jsx(StyledSkeleton, {}), !isLoading && error && _jsx(InfoBox, { firstInfoBoxLine: error }), !isLoading && !error && hasItems && children, !isLoading && !error && !hasItems && (_jsx(InfoBox, { variant: 'info', firstInfoBoxLine: emptyText !== null && emptyText !== void 0 ? emptyText : 'No items.' }))] })] }));
